import React from 'react';
import ReactDOM from 'react-dom';
import { T } from '../../../../../common/locale/translate';
import { Validate } from '../../../../../common/validation/validate';
import { trackAdWordsConversion } from '../../../services/adWords';
import { trackAnalyticsEvent } from '../../../services/analytics';
import { send_on_email } from '../../../services/services';

export default class SendOffer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      placeholder: T('send_offer_to_mail'),
      open: false,
      options: {
        pristine: { icon: 'fa-envelope-o', title: T('send_offer_to_mail') },
        open: { icon: 'fa-check', title: T('click_to_send') },
        pending: { icon: 'fa-envelope-open-o', title: T('email_pending') },
        sent: { icon: 'fa-thumbs-o-up', title: T('offer_sent') },
        warning: { icon: 'fa-check', title: T('offer_mail_invalid') },
        error: { icon: 'fa-envelope-o', title: T('offer_send_error') }
      },
      is_sent: false,
      currentStatus: 'pristine'
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  }

  render() {
    const status = this.state.currentStatus;
    const { icon, title } = this.state.options[status];

    return (
      <div className={`send-offer-wrapper ${status}`}>
        <div className={`notify-input ${this.state.open ? 'open' : ''}`}>
          <input
            ref="email"
            type="email"
            placeholder={this.state.placeholder}
            className="send-main-input"
            onClick={e => e.stopPropagation()}
          />
        </div>
        <div className="send-offer" onClick={this.handleClick} title={title}>
          <i className={`fa ${icon}`} />
        </div>
      </div>
    );
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if (
      (!domNode || !domNode.contains(event.target)) &&
      this.state.open &&
      this.isFieldEmpty('email')
    ) {
      const currentStatus = !this.state.open ? 'open' : 'pristine';
      this.setState({ open: false, currentStatus });
    }
  };

  isFieldEmpty(name) {
    return this.refs[name].value ? false : true;
  }

  handleClick = e => {
    e.stopPropagation();

    if (this.isFieldEmpty('email')) {
      const currentStatus = !this.state.open ? 'open' : 'pristine';
      this.setState({ open: !this.state.open, currentStatus });
    } else {
      this.handleSubmit();
    }
  };

  handleSubmit = () => {
    const email = this.refs.email.value;
    if (Validate.email(email)) {
      this.setState({ open: false, currentStatus: 'pending' });
      send_on_email(
        { client: { email }, offer: this.props.offer, language: 'pl' },
        this.props.token
      )
        .then(() => {
          this.refs.email.value = '';
          this.setState({ is_sent: true, currentStatus: 'sent' });
          trackAdWordsConversion(715672677, 'oCICCLWLn3IQrZTnlwM');
          trackAnalyticsEvent(
            'oferty',
            'wysłanie oferty na email',
            'wysłanie oferty na email'
          );
          setTimeout(
            function() {
              this.setState({ currentStatus: 'pristine' });
            }.bind(this),
            5000
          );
        })
        .catch(() => {
          this.refs.email.value = '';
          this.setState({
            open: false,
            currentStatus: 'error',
            is_sent: false
          });
        });
    } else {
      this.setState({ currentStatus: 'warning' });
    }
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/send_offer.jsx